<div class="route-component">
    <div class="form-component">
        <h4 *ngIf="batchId === 0">
            Create Performance Import Batch
        </h4>

        <form #form="ngForm" (ngSubmit)="onSave(form)">

            <div class="input-group">
                <auto-complete-dropdown
                    [options]="periods"
                    [label]="'Period'"
                    [placeholder]="'Select a period...'"
                    [initialValue]="selectedPeriodId"
                    [required]="true"
                    [invalid]="!selectedPeriodId"
                    [validationMessage]="'Period is required'"
                    [displayWith]="displayPeriod"
                    (selectionChange)="onPeriodChange($event)">
                </auto-complete-dropdown>
            </div>

            <div class="input-group">
                <auto-complete-dropdown
                    [options]="insurers"
                    [label]="'Insurer'"
                    [placeholder]="'Select an insurer...'"
                    [initialValue]="selectedInsurerId"
                    [required]="true"
                    [invalid]="!selectedInsurerId"
                    [validationMessage]="'Insurer is required'"
                    [displayWith]="displayInsurer"
                    (selectionChange)="onInsurerChange($event)">
                </auto-complete-dropdown>
            </div>

            <div class="input-group" *ngIf="showClientDropdown">
                <auto-complete-dropdown
                    [options]="clients"
                    [label]="'Client'"
                    [placeholder]="'Select a client...'"
                    [initialValue]="selectedClientId"
                    [required]="true"
                    [invalid]="!selectedClientId"
                    [validationMessage]="'Client is required'"
                    [displayWith]="displayClient"
                    (selectionChange)="onClientChange($event)">
                </auto-complete-dropdown>
            </div>

            <div class="input-group" *ngIf="selectedClientId && selectedClientId > 0 && showClientDropdown">
                <auto-complete-dropdown
                    [options]="clientAreas"
                    [label]="'Client Area'"
                    [placeholder]="'Select a client area...'"
                    [initialValue]="selectedClientAreaId"
                    [required]="true"
                    [invalid]="!selectedClientAreaId && formSubmitted && clientAreas.length > 0"
                    [validationMessage]="'Client Area is required'"
                    [displayWith]="displayClientArea"
                    (selectionChange)="onClientAreaChange($event)">
                </auto-complete-dropdown>
                <div *ngIf="clientAreas.length === 0">
                    <span class="error">No available client areas for insurer and client</span>
                </div>
            </div>

            <div class="input-group" *ngIf="(selectedInsurerId && selectedInsurerId > 0 && !showClientDropdown) || (selectedClientAreaId && selectedClientAreaId > 0)">
                <label for="fileInput">
                    Performance File:<span class="required"> * </span>
                </label>
                <div>
                    <label for="fileInput" class="custom-file-label" [class.invalid]="fileControl.invalid">
                        {{ selectedFileName || 'Choose a file' }}
                    </label>
                    <input id="fileInput" name="fileControl" ngModel #fileControl="ngModel" type="file" class="custom-file-input" accept=".xlsx" (change)="onFileSelected($event)" required/>
                    <div *ngIf="fileControl.invalid">
                        <span class="error">Performance file is required</span>
                    </div>
                </div>
            </div>

            <div class="action-bar">
                <button type="submit" class="button"
                    [class.button-progress]="isSaving"
                    [style.--progress]="uploadProgress + '%'"
                    [disabled]="
                    !selectedPeriodId ||
                    !selectedInsurerId ||
                    (showClientDropdown && (!selectedClientId || !selectedClientAreaId)) ||
                    form.invalid || isSaving">
                    <span *ngIf="isSaving" class="progress-percent">{{ uploadProgress }}%</span>
                    <i *ngIf="!isSaving" class="fas fa-save"></i>
                    {{ isSaving ? uploadMessage : 'Save' }}
                </button>
                <button type="button" class="button-cancel" (click)="onCancel()" [disabled]="isSaving">
                    <i class="fas fa-cancel"></i> Cancel
                </button>
            </div>
        </form>
    </div>
</div>
